import { Component, OnInit, Inject, ViewChild, ElementRef, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { FormValidatorService } from '../../shared-services/form-validator.service';
import { HistoryProvider } from '../../core/browser-providers';
import { MediaService } from '../../shared-services/media.service';
import { Http } from '@angular/http';
import { NavigationService } from '../../shared-services/navigation.service';
import { NgForm } from '@angular/forms';
import { DialogService } from '../../shared-components/modals/dialog.service';
import { Sector } from './sector.model';

@Component({
  selector: 'app-sector-add-edit',
  templateUrl: './sector-add-edit.component.html',
  styleUrls: ['./sector-add-edit.component.scss']
})
export class SectorAddEditComponent implements OnInit {

  visible = true;
  selectable = true;
  removable = true;
  addOnBlur = false;
  @ViewChild('form') public roleForm: NgForm;

  validationFail = false;
  sector: Sector;

  messageTitle: string;

  isHD = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private snackService: SnackService,
    private backendService: BackendService,
    private formValidatorService: FormValidatorService,
    @Inject(HistoryProvider) private history: History,
    private http: Http,
    private mediaService: MediaService,
    private navigationService: NavigationService,
    private dialogService: DialogService,
  ) { }

  ngOnInit() {

    this.route.data.subscribe(data => {
      this.sector = data.user;
      this.sector.description = this.sector.id ? this.sector.description : '';
    });

    this.messageTitle = this.sector.id  ? 'Edición de sectores comerciales' : 'Alta de sectores comerciales';

    this.mediaService.isHighDefinition.subscribe(isHD => this.isHD = isHD);
  }

  back() {
    this.navigationService.back();
  }

  async save() {
    if (this.validateForm()) {
      this.invokeSave();
    }
  }

  validateForm() {
    let validationsOK = false;

    // Valida el resto de los controles con sus validadores
    if (this.formValidatorService.isFormValid(this.roleForm)) {
      validationsOK = true;
      this.validationFail = false;
    } else {
      validationsOK = false;
      this.validationFail = true;
    }

    return validationsOK;
  }

  private async invokeSave() {

    if (this.validateForm()) {
      this.ConfirmSave();
    }

    return;
  }

  async ConfirmSave() {
    this.dialogService.confirm(this.messageTitle,
    '¿Está seguro que desea guardar el sector ' + this.sector.description + '?')
    .then( res => {
      if (res) {
        this.saveMotivosRechazo(res);
      }
    });
  }

  async saveMotivosRechazo(res) {
    if (res) {

      this.snackService.spinner(true);

      if (this.sector.id) { // Update
        try {
          await await this.backendService.update(Sector.path + this.sector.id, this.sector);
          this.snackService.success('Sector comercial editado');
          this.router.navigate(['/sectores']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
      } else {
        try {
          await this.backendService.create(Sector.path, this.sector);
          this.snackService.success('Sector comercial creados');
          this.router.navigate(['/sectores']);
        } catch (ex) {
          this.snackService.error(ex.message);
        } finally {
          this.snackService.spinner(false);
        }
      }
    }
  }


}



// WEBPACK FOOTER //
// ./src/app/cliente/sectores/sector-add-edit.component.ts